<div class="row justify-content-center">
  <div class="col-md-8 col-lg-8 col-12">
    <h3>{{ "accounts.password_change.title" | translate }}</h3>
      <form #form="ngForm" (ngSubmit)="form.form.valid && submit(form)" [matchPassword]="['newPassword','newPasswordConfirm']" novalidate>
        <p>{{ "accounts.password_change.confirm_password" | translate }}</p>
        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label>{{ "accounts.password_change.password" | translate }}</label>
              <div class="input-group">
                <div class="input-group-append">
                  <button
                    [ngClass]="showPassword ? 'btn rounded-left btn-outline-success' : 'btn rounded-left btn-outline-primary'"
                    type="button"
                    (click)="this.showPassword = !this.showPassword">

                    <i *ngIf="showPassword; else eyeSlash" class="fas fa-eye"></i>
                    <ng-template #eyeSlash>
                      <i class="fas fa-eye-slash"></i>
                    </ng-template>
                  </button>
                </div>
                <input
                  [type]="showPassword ? 'text' : 'password'"
                  class="form-control"
                  name="password"
                  [(ngModel)]="password"
                  #passwordVal="ngModel"
                  [ngClass]="inputFieldCss(passwordVal, form)"
                  (blur)="handleBlurPassword()"
                  [minLength]="8"
                  required>
              </div>
              <app-field-error-display [control]="passwordVal" [form]="form"></app-field-error-display>
              <div class="text-right">
                <label style="font-size: small">{{ "shared.login.show-password" | translate }}</label>
                <input class="ml-2" type="checkbox" name="newNip" value="nip" [(ngModel)]="showPassword">
              </div>
            </div>

          </div>
          <div class="col-12">
            <div class="form-group">
              <label>{{ "accounts.password_change.new_password" | translate }}</label>
              <div class="input-group">
                <div class="input-group-append">
                  <button
                    [ngClass]="showNewPassword ? 'btn rounded-left btn-outline-success' : 'btn rounded-left btn-outline-primary'"
                    type="button"
                    (click)="this.showNewPassword = !this.showNewPassword">

                    <i *ngIf="showNewPassword; else eyeSlashNew" class="fas fa-eye"></i>
                    <ng-template #eyeSlashNew>
                      <i class="fas fa-eye-slash"></i>
                    </ng-template>
                  </button>
                </div>
                <input
                  [type]="showNewPassword ? 'text' : 'password'"
                  class="form-control"
                  name="newPassword"
                  [(ngModel)]="newPassword"
                  #newPasswordVal="ngModel"
                  (ngModelChange)="passwordValidation()"
                  [ngClass]="inputFieldCss(newPasswordVal, form)"
                  (blur)="handleBlurChangePass('first')"
                  [minLength]="8"
                  required>
              </div>
              <app-field-error-display [control]="newPasswordVal" [form]="form"></app-field-error-display>
              <div class="text-right">
                <label style="font-size: small">{{ "shared.login.show-password" | translate }}</label>
                <input class="ml-2" type="checkbox" name="newNip1" value="nip" [(ngModel)]="showNewPassword">
              </div>
            </div>
          </div>
          <div *ngIf="newPassword" class="col-12">
            <p *ngIf="!passwordMinLength || !passwordCapsLower || !passwordNumber || !passwordSpecial || passwordSequences || passwordRepetition || !passwordSpaces">{{ "accounts.password_change.password_requirements" | translate }}</p>
            <ul>
              <li class="text-danger" *ngIf="!passwordMinLength">
                <p>{{ "accounts.password_change.length" | translate }}</p>
              </li>
              <li class="text-danger" *ngIf="!passwordCapsLower">
                <p class="p-0 m-0">{{ "accounts.password_change.upper_lower" | translate }}</p>
                <p class="small example">{{ "accounts.password_change.upper_lower_ex" | translate }}</p>
              </li>
              <li class="text-danger" *ngIf="!passwordNumber">
                <p class="p-0 m-0">{{ "accounts.password_change.number" | translate }}</p>
                <p class="small example">{{ "accounts.password_change.number_ex" | translate }}</p>
              </li>
              <li class="text-danger" *ngIf="!passwordSpecial">
                <p class="p-0 m-0">{{ "accounts.password_change.special_character" | translate }}</p>
                <p class="small example">{{ "accounts.password_change.special_character_ex" | translate }}</p>
              </li>
              <li class="text-danger" *ngIf="passwordSequences">
                <p class="p-0 m-0">{{ "accounts.password_change.sequences" | translate }}</p>
                <p class="small example">{{ "accounts.password_change.sequences_ex" | translate }}</p>
              </li>
              <li class="text-danger" *ngIf="passwordRepetition" >
                <p class="p-0 m-0">{{ "accounts.password_change.repetition" | translate }}</p>
                <p class="small example">{{ "accounts.password_change.repetition_ex" | translate }}</p>
              </li>
              <li class="text-danger" *ngIf="!passwordSpaces" >
                <p class="p-0 m-0">{{ "accounts.password_change.spaces" | translate }}</p>
                <p class="small example">{{ "accounts.password_change.spaces_ex" | translate }}</p>
              </li>
            </ul>
          </div>
          <div class="col-12">
            <div class="form-group">
              <label>{{ "accounts.password_change.confirm_new" | translate }}</label>
              <div class="input-group">
                <div class="input-group-append">
                  <button
                    [ngClass]="showNewPasswordConfirm ? 'btn rounded-left btn-outline-success' : 'btn rounded-left btn-outline-primary'"
                    type="button"
                    (click)="this.showNewPasswordConfirm = !this.showNewPasswordConfirm">

                    <i *ngIf="showNewPasswordConfirm; else eyeSlashConfirm" class="fas fa-eye"></i>
                    <ng-template #eyeSlashConfirm>
                      <i class="fas fa-eye-slash"></i>
                    </ng-template>
                  </button>
                </div>
                <input
                  [type]="showNewPasswordConfirm ? 'text' : 'password'"
                  class="form-control"
                  name="newPasswordConfirm"
                  [(ngModel)]="newPasswordConfirm"
                  #passwordConfirmVal="ngModel"
                  [ngClass]="inputFieldCss(passwordConfirmVal, form)"
                  (blur)="handleBlurChangePass('second')"
                  [minLength]="8"
                  (paste)="false"
                  required>
              </div>
              <app-field-error-display [control]="passwordConfirmVal" [form]="form"></app-field-error-display>
              <div class="text-right">
                <label style="font-size: small">{{ "shared.login.show-password" | translate }}</label>
                <input class="ml-2" type="checkbox" name="newNip2" value="nip" [(ngModel)]="showNewPasswordConfirm">
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 text-right mb-2">
          <button type="submit" class="btn btn-primary" [disabled]="!form.form.valid || !this.passwordSpaces || !this.passwordMinLength || this.passwordRepetition || this.passwordSequences || !this.passwordNumber || !this.passwordSpecial || !this.passwordCapsLower">{{ "accounts.password_change.change" | translate }}</button>
        </div>
      </form>
    </div>
  </div>